export default "__VITE_ASSET__732c2c84__"